export {
  HeadingColor,
  HeadingSize,
  HeadingType,
  HeadingWeight,
} from './heading.component';
